import React from "react";
import { LegalLayout } from "../components/LegalLayout";

const Terms = () => (
  <LegalLayout overline="Legal" title="Terms of Use" lastUpdated="December 2025">
    <h2>General</h2>
    <p>
      This website is operated by Lawfields Solicitors. By accessing or using this website you
      agree to be bound by these terms. The content on this website is for general information only
      and does not constitute legal advice. Reading our website does not create a solicitor-client
      relationship.
    </p>

    <h2>Regulatory information</h2>
    <p>
      Lawfields Solicitors is authorised and regulated by the Solicitors Regulation Authority
      (SRA No. 316284). The SRA Standards and Regulations can be viewed at
      <a href="https://www.sra.org.uk" target="_blank" rel="noreferrer"> www.sra.org.uk</a>.
    </p>

    <h2>Intellectual property</h2>
    <p>
      All content on this website (text, layout, graphics and logos) is the property of Lawfields
      Solicitors or its licensors and is protected by copyright. You may view, download and print
      content for personal, non-commercial use only.
    </p>

    <h2>Limitation of liability</h2>
    <p>
      While we take reasonable care to ensure the information on this site is accurate at the time
      of publication, we make no warranties or representations regarding its accuracy or
      completeness. We exclude liability for any loss arising from reliance on website content to
      the fullest extent permitted by law.
    </p>

    <h2>External links</h2>
    <p>
      This website may contain links to external sites. We are not responsible for the content of
      those sites and inclusion of a link does not imply endorsement.
    </p>

    <h2>Governing law</h2>
    <p>
      These terms are governed by the laws of England and Wales. Any disputes shall be subject to
      the exclusive jurisdiction of the courts of England and Wales.
    </p>
  </LegalLayout>
);

export default Terms;
